export default "__VITE_ASSET__DHeYOqSl__"